<template>
  <div class="policy-page">
    <trsShopBreadcrumb
      class="policy-page__breadcrumb"
      :breadcrumbList="breadcrumbList"
      :skip="true"
    />
    <div class="policy-content">
      <section class="policy-section">
        <h3 class="policy-section__heading">Easy Return Process</h3>
        <p class="policy-text">Step 1 – Contact Us</p>
        <p class="policy-text">
          Please contact our customer service team at
          <a href="mailto:sales@tarazon.cn" class="policy-link">sales@tarazon.cn</a>
          and provide your order number along with the reason for your return request.
        </p>
        <p class="policy-text">Step 2 – Receive Return Instructions</p>
        <p class="policy-text">
          Once your request has been reviewed and approved, we will provide return instructions and the return address by email.
        </p>
        <p class="policy-text">Step 3 – Return &amp; Refund Processing</p>
        <p class="policy-text">
          After we receive and inspect the returned item, your refund will be processed through the original payment method within 3–5 business days.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">Return Policy</h3>
        <p class="policy-text">We offer a 30-day return policy from the date of delivery.</p>
        <p class="policy-text">To be eligible for a return, the item must:</p>
        <ul class="policy-list policy-list--dot">
          <li>Be unused and uninstalled</li>
          <li>Be in its original condition</li>
          <li>Be returned in the original packaging</li>
          <li>Not be modified, damaged, or altered</li>
        </ul>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">Return Shipping Costs</h3>
        <p class="policy-text">We will cover the return shipping costs if:</p>
        <ul class="policy-list policy-list--dot">
          <li>You received the wrong product</li>
          <li>The item was damaged during transit</li>
          <li>The item has a verified manufacturing defect</li>
        </ul>
        <p class="policy-text">For all other returns, customers are responsible for return shipping costs.</p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">Important Return Notes</h3>
        <ul class="policy-list policy-list--dot">
          <li>Please do not return any item without obtaining return authorization from us first.</li>
          <li>Returns sent without prior authorization may not be accepted or processed.</li>
          <li>We recommend using a trackable shipping service when returning products.</li>
        </ul>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">Refund Processing</h3>
        <p class="policy-text">
          Once your return is received and inspected, we will notify you by email regarding the approval or rejection of your refund request.
        </p>
        <p class="policy-text">
          If approved, the refund will be issued to your original payment method within 3–5 business days.
        </p>
        <p class="policy-text">
          Partial refunds may apply if returned items are incomplete, damaged, or missing components.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">Order Cancellation</h3>
        <p class="policy-text">Orders may be canceled before shipment.</p>
        <p class="policy-text">
          Once an order has been shipped or a tracking number has been generated, cancellation is no longer possible.
        </p>
        <p class="policy-text">
          For customer-initiated cancellations or returns, non-refundable payment processing fees charged by payment providers may be deducted from the refund amount where permitted by applicable laws.
        </p>
      </section>

      <hr class="policy-divider">

      <section class="policy-section">
        <h3 class="policy-section__heading">Warranty Policy</h3>
        <p class="policy-text">
          All products are covered by a limited one-year warranty against manufacturing defects from the date of purchase.
        </p>
        <ul class="policy-list policy-list--dot">
          <li>The warranty does not cover:</li>
          <li>Normal wear and tear</li>
          <li>Improper installation</li>
          <li>Product modification</li>
          <li>Accidental damage</li>
          <li>Damage caused by misuse, racing, extreme riding, or violent riding</li>
        </ul>
        <p class="policy-text">
          For products damaged as a result of aggressive or extreme riding conditions, warranty coverage is limited to six months from the purchase date.
        </p>
        <p class="policy-text">
          To submit a warranty claim, please contact
          <a href="mailto:sales@tarazon.cn" class="policy-link">sales@tarazon.cn</a>
          with your order number, photos, and a description of the issue.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import trsShopBreadcrumb from '@/components/layout/shopping/breadcrumb.vue';

export default {
  name: 'trsReturnPolicy',
  mixins: [Mixin],
  components: {
    trsShopBreadcrumb
  },
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'),
          path: '/index'
        },
        {
          name: 'RETURN POLICY',
          path: '/trsReturnPolicy'
        }
      ]
    };
  },
};
</script>

<style scoped lang="less">
.policy-page {
  width: 1200px;
  margin: 0 auto;
}

.policy-page__breadcrumb {
  margin: 0 auto;
  width: 1200px;
}

.policy-content {
  background-color: #ffffff;
  margin-bottom: 20px;
  padding: 32px 40px 40px;
  color: #333;
  font-family: Arial, 'Microsoft YaHei', sans-serif;
  line-height: 1.8;
}

.policy-section {
  margin-bottom: 0;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-section__heading {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  line-height: 1.5;
}

.policy-text {
  margin: 0 0 12px;
  font-size: 14px;
  color: #333;
  text-align: left;

  &:last-child {
    margin-bottom: 0;
  }
}

.policy-list {
  margin: 0 0 12px;
  font-size: 14px;
  color: #333;

  li {
    margin-bottom: 6px;
    line-height: 1.7;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

// Word 原文圆点列表（•）
.policy-list--dot {
  padding-left: 0;
  list-style: none;

  li {
    position: relative;
    padding-left: 16px;

    &::before {
      content: '\2022';
      position: absolute;
      left: 0;
      top: 0;
      font-size: 14px;
      line-height: 1.7;
      color: #333;
    }
  }
}

.policy-divider {
  margin: 24px 0;
  border: 0;
  border-top: 1px solid #e8e8e8;
}

.policy-link {
  color: #333;
  text-decoration: none;

  &:hover {
    color: #89b92a;
    text-decoration: underline;
  }
}
</style>
